import { BehaviorSubject } from "rxjs";
import { singleton } from "tsyringe";

interface ViewCardOpenStatus {
    waysToEarnPoints: boolean;
    waysToSpendPoints: boolean;
}

@singleton()
class RewardsPopUpRootWidgetCardManager {
    public activeCardId$ = new BehaviorSubject<number | null>(null);
    private viewCardOpenStatus: ViewCardOpenStatus = {
        waysToEarnPoints: false,
        waysToSpendPoints: false,
    };

    public setActiveCardId = (cardId: number | null): void => {
        this.activeCardId$.getValue() === cardId
            ? this.activeCardId$.next(null)
            : this.activeCardId$.next(cardId);
    };

    public openCardOnMount = ({
        isCustomer,
        cardId,
        view,
    }: {
        isCustomer: boolean;
        cardId: number | undefined;
        view: keyof ViewCardOpenStatus;
    }): void => {
        if (this.viewCardOpenStatus[view]) return;

        if (isCustomer && cardId) {
            this.setActiveCardId(cardId);
            this.viewCardOpenStatus[view] = true;
        }
    };
}

export default RewardsPopUpRootWidgetCardManager;
